import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import { postOrder, returnSection } from '../../../store/actions/order';
import { GetUserDetails, PostOrder } from '../../../store/actions/kalapost';
import { getOrdersDetails } from '../../../store/actions/order';
import { successMessage } from '../../../utils/message';
import { seperateNumber } from 'persianhelper';

const CalcPrice = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
   const { executeRecaptcha } = useGoogleReCaptcha();

   const {
      section,
      price,
      originLat,
      originLng,
      serviceTypeId,
      deliveryTypeId,
      destination,
      packages,
      packing,
      assurance,
      fullName,
      phoneNumber,
      address,
      postalCode,
      paymentTimeId,
      paymentTypeId,
      serviceFee,
      origin,
      pickup,
      nationalId,
   } = useSelector((state) => state.order);

   const [registerOrder, setRegisterOrder] = useState({
      payment: paymentTypeId,
   });

   const GetDetails = async (trackNum) => {
      const token = await handleReCaptchaVerify();
      const res = await GetUserDetails(trackNum, token);
      res.status && dispatch(getOrdersDetails(res.data));
   };
   const handlePay = async () => {
      const token = await handleReCaptchaVerify();
      const res = await dispatch(
         postOrder(
            Number(originLat),
            Number(originLng),
            serviceTypeId,
            deliveryTypeId,
            destination,
            packages,
            packing,
            assurance,
            fullName,
            phoneNumber,
            address,
            postalCode,
            paymentTimeId,
            registerOrder.payment,
            serviceFee,
            price,
            origin,
            pickup,
            nationalId,
            token
         )
      );
      if (res?.status) {
         successMessage(res.data.message);
         navigate('/orders/');
         GetDetails(res.data.trackingNumber);
      }
   };
   const handleReCaptchaVerify = useCallback(async () => {
      if (!executeRecaptcha) {
         return;
      }
      const token = await executeRecaptcha();
      return token;
   }, [executeRecaptcha]);

   return (
      <div
         className={section === 5 ? 'progresstabs__content active-nav' : 'progresstabs__content'}
         style={{ minHeight: 'unset' }}
      >
         <h1 className='progresstabs__content-title'>هزینه ارسال کالای شما</h1>
         <h1 className='progresstabs__content-price'>{seperateNumber(price + '')} تومان</h1>
         {paymentTimeId !== '2' ? (
            <>
               <h2 className='progresstabs__content-way'>پرداخت از طریق</h2>
               <ul className='progresstabs__content-list'>
                  <li
                     // onClick={() =>
                     //   setOrderd({ ...orderd, paymentType: "درگاه اینترنتی" })
                     // }
                     className='progresstabs__content-list-item'
                     style={{ opacity: 0.5, pointerEvents: 'none' }}
                  >
                     <img
                        src='./img/credit-card-svgrepo-com.png'
                        alt='type'
                        className='progresstabs__content-list-img'
                     />
                     <p className='progresstabs__content-list-type'>درگاه اینترنتی</p>
                  </li>
                  <li
                     className='progresstabs__content-list-item'
                     style={{ opacity: 0.5, pointerEvents: 'none' }}
                     // onClick={() => setOrderd({ ...orderd, paymentType: "کیف پول" })}
                  >
                     <img
                        src='./img/wallet-svgrepo-com.png'
                        alt='type'
                        className='progresstabs__content-list-img'
                     />
                     <p className='progresstabs__content-list-type'>کیف پول</p>
                     <p className='progresstabs__content-list-type'>موجودی :0 تومان</p>
                  </li>
                  <li
                     className='progresstabs__content-list-item active'
                     onClick={() => setRegisterOrder({ ...registerOrder, payment: '2' })}
                  >
                     <img
                        src='./img/home-delivery.png'
                        alt='type'
                        className='progresstabs__content-list-img'
                     />
                     <p className='progresstabs__content-list-type'>در محل</p>
                  </li>
               </ul>
            </>
         ) : null}

         <div className='progresstabs__content-buttons'>
            <button
               className='btn btn--secondary return-btn'
               onClick={() => dispatch(returnSection())}
            >
               بازگشت
            </button>
            <button className='btn btn--secondary' onClick={handlePay}>
               پرداخت
            </button>
         </div>
      </div>
   );
};

export default CalcPrice;
